import { SubmitHandler, useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { storeData } from "../../../utilities/localStorage";
import { AuthAccessLogin, FormAccessLogin } from "../models/login.model";
import { authValidateService } from "../services/login.service";
import logo from "../../../assets/img/Gemini_Generated_Image_arpd32arpd32arpd.png";

function FormLogin(): JSX.Element {
  const [valuePassword, setValuePassword] = useState<string>("");
  const [valueUser, setValueUser] = useState<string>("");
  const [activeButton, setActiveButton] = useState<boolean>(false);
  const [validateAccess, setValidateAccess] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const navigate = useNavigate();
  const { handleSubmit } = useForm<FormAccessLogin>({ mode: "onChange" });

  const onSubmit: SubmitHandler<FormAccessLogin> = async () => {
    setActiveButton(false);
    try {
      const data: AuthAccessLogin = { user: valueUser, password: valuePassword };
      const response = await authValidateService(data);

      if (response.data) {
        storeData("idUser", response.data?.idUser);
        storeData("role", response.data?.role);
        storeData("isAdmin", response.data?.role === "admin" ? 1 : 0);
        storeData("activeSession", true);
        setValidateAccess(false);
        setValuePassword("");
        setValueUser("");
        navigate(response.data.role === "admin" ? "/admin" : "/inicio");
      } else {
        setValidateAccess(true);
      }
    } catch {
      setValidateAccess(true);
    } finally {
      setActiveButton(!!(valuePassword && valueUser));
    }
  };

  useEffect(() => {
    setActiveButton(!!(valuePassword && valueUser));
  }, [valuePassword, valueUser]);

  return (
    <div className="background-image">
      <div className="login-wrap">

        {/* Panel izquierdo — solo imagen de fondo + texto */}
        <div className="login-left">
          <img src={logo} alt="BICapital" className="login-logo" />
          <div className="login-left-bg" />
        </div>

        {/* Panel derecho */}
        <div className="login-right">
          <h2 className="login-heading">Bienvenido</h2>
          <p className="login-subheading">Ingresa tus credenciales para continuar</p>

          <form onSubmit={handleSubmit(onSubmit)}>

            <div className="login-field">
              <label className="login-label" htmlFor="username">Usuario</label>
              <div className="login-field-inner">
                <i className="pi pi-user login-field-icon" />
                <input
                  id="username"
                  name="username"
                  type="text"
                  autoFocus
                  placeholder="nombre de usuario"
                  value={valueUser}
                  onChange={(e) => setValueUser(e.target.value)}
                  className="login-input"
                />
              </div>
            </div>

            <div className="login-field">
              <label className="login-label" htmlFor="password">Contraseña</label>
              <div className="login-field-inner">
                <i className="pi pi-lock login-field-icon" />
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={valuePassword}
                  onChange={(e) => setValuePassword(e.target.value)}
                  className="login-input login-input--password"
                />
                <button
                  type="button"
                  className="login-toggle-pw"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Mostrar contraseña"
                >
                  <i className={`pi ${showPassword ? "pi-eye-slash" : "pi-eye"}`} />
                </button>
              </div>
              {validateAccess && (
                <p className="login-error">Usuario o contraseña incorrecto</p>
              )}
            </div>

            <button
              type="submit"
              disabled={!activeButton}
              className={`login-btn ${activeButton ? "" : "login-btn--disabled"}`}
            >
              Ingresar
            </button>

            <p className="login-tagline">
              Plataforma para gestionar tus finanzas de manera eficiente y segura.
            </p>

          </form>
        </div>

      </div>
    </div>
  );
}

export default FormLogin;